import axios from "../../../../util/axiosconfig";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { showError } from "../../../../util/ShowStatus";
import { ROLES } from "../../../../util/roleNameConstants";

export const fetchUsersList = async (
  setUsersList: any,
  setUsersListLoading: any,
  setSelectedDriver: any,
  setFormValues: any,
  setSelectedVehicle: any,
  toast: any
) => {
  try {
    setUsersListLoading(true);
    const response = await axios.get(`tl-admin/hs-user-driver-list`);
    setUsersList(response.data.result);
    if (!localStorage.roleName.includes(ROLES.HANDS_ADMIN)) {
      // Optionally, set default driver here if needed, e.g. first user in list after fetch
      setSelectedDriver(response.data.result[0]);
      setFormValues((prev: any) => ({
        ...prev,
        driver: {
          userID: response.data.result[0]?.userID ?? null,
          displayName: response.data.result[0]?.displayName ?? null,
        },
      }));
    }
    // if(response.data.previousSelectedVehicle){
    //   setSelectedVehicle(response.data.previousSelectedVehicle);
    //   setFormValues((prev: any) => ({
    //     ...prev,
    //     vehicle: {
    //       vehicleID: response.data.previousSelectedVehicle?.vehicleID ?? null,
    //       vehicleTypeID: response.data.previousSelectedVehicle?.vehicleTypeID ?? null,
    //       registration_no: response.data.previousSelectedVehicle?.registration_no ?? null,
    //       vehicleType: response.data.previousSelectedVehicle?.vehicleType ?? null,
    //       capacity: response.data.previousSelectedVehicle?.capacity ?? null,
    //       isActive: response.data.previousSelectedVehicle?.isActive ?? null,
    //       make: response.data.previousSelectedVehicle?.make ?? null,
    //       model: response.data.previousSelectedVehicle?.model ?? null,
    //     },
    //   }));
    // }
    setUsersListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setUsersListLoading(false);
    showError(error, toast);
  }
};

export const fetchVehicles = async (
  setVehiclesList: any,
  setVehicleListLoading: any,
  toast: any
) => {
  try {
    setVehicleListLoading(true);
    const response = await axios.get("tl-admin/vehicle/all?page=-1");
    const filteredVehicles = response.data.result.filter(
      (vehicle: any) => vehicle.registration_no !== "No Vehicle"
    );
    setVehiclesList(filteredVehicles);
    setVehicleListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setVehicleListLoading(false);
    showError(error, toast);
  }
};

export const fetchAllVehicleAssestCheckForm = async (
  setVehicleAssestCheckForm: any,
  setVehicleAssestCheckFormLoading: any,
  filters: any,
  toast: any
) => {
  try {
    const params: any = {};
    if (filters && filters.startDate && filters.endDate) {
      // Convert to UTC ISO string
      params.startDate = filters.startDate;
      params.endDate = filters.endDate;
    }
    setVehicleAssestCheckFormLoading(true);
    const response = await axios.get("health-and-safety/vehicle-asset-form", {
      params,
    });
    setVehicleAssestCheckForm(response.data.result);
    setVehicleAssestCheckFormLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setVehicleAssestCheckFormLoading(false);
    showError(error, toast);
  }
};

export const getFormByFormID = async (
  setFormData: any,
  setFormDataLoading: any,
  formIDParam: number,
  navigate: any,
  toast: any
) => {
  try {
    setFormDataLoading(true);
    const response = await axios.get(
      `health-and-safety/vehicle-asset-form-by-id?formID=${formIDParam}`
    );
    if (response.data.result.length === 0) {
      showError("Form not found", toast);
      setFormDataLoading(false);
      navigate("/layout/leak-detection/vehicle-assessment-list");
      return;
    }
    setFormData(response.data.result);
    setFormDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setFormDataLoading(false);
    showError(error, toast);
  }
};
